import { Component } from 'react'
import { HiPlus } from 'react-icons/hi'
import { appRef } from '../../app'
import { getString } from '../../locale'
import { SoftwareVersionForm } from './software-version-form'
import { RouteComponentProps } from 'react-router-dom'
import { ClientModel } from '../../api/clients'
import { SoftwareVersionComponent } from '../../api/0x0001/software-versions'

type Props = RouteComponentProps

type State = {}

export class CreateSoftwareVersion extends Component<Props, State> {
    state: State = {}

    componentDidMount = () => {
        appRef.setHeader(<HiPlus className="me-2" size={28} />, () => getString('pagelabels.new-software-version'))
    }

    render() {
        const params = new URLSearchParams(this.props.location.search)
        const modelParam = params.get('model')
        const parsedModel = modelParam === null ? NaN : Number(modelParam)
        const allowedModels = new Set<number>([
            ClientModel.Standard,
            ClientModel.LTI525S,
            ClientModel.SYRUP_TOWER,
            ClientModel.FILTER_FILLER,
            ClientModel.LTSP101,
            ClientModel.LTSP70,
            ClientModel.LTSP175,
            ClientModel.LTCB220,
            ClientModel.LTCB226,
        ])
        const initialModel = Number.isFinite(parsedModel) && allowedModels.has(parsedModel) ? (parsedModel as ClientModel) : undefined
        const componentParam = params.get('component')
        const initialComponent: SoftwareVersionComponent = componentParam === 'c6' ? 'c6' : 'app'
        return (
            <div className="container">
                <SoftwareVersionForm initialModel={initialModel} initialComponent={initialComponent} />
            </div>
        )
    }
}
